
import {catchError, map} from 'rxjs/operators';
import { Observable } from 'rxjs';
import { api, handleError } from '../shared/api-loaders';
import { Injectable } from '@angular/core';
import { License } from './license.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class LicenseService {

  constructor(private _http: HttpClient) { }

  getLicenses(): Observable<License[]> {
    return this._http
      .get(api.licenses()).pipe(
      catchError(handleError),);
  }
  
  
}
